import { RouteConfig } from '@dfl/react-security';
import { lazy } from 'react';

export const MainApp = lazy(() => import('routes/MainApp'));

export const AuthApp = lazy(() => import('routes/AuthApp'));

export const routes: RouteConfig = {
  Auth: {
    path: '/auth/*',
    onlyAnonymous: true,
    component: AuthApp,
  },
  MainLayout: {
    path: '*',
    authenticated: true,
    redirect: '/auth/login',
    component: MainApp,
  },
};
